var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-well mx-0 gl-max-w-full"},[_c('div',{staticClass:"well-segment"},[_c('ul',{staticClass:"gl-m-0 gl-list-none gl-p-0"},[_c('commit-item',{attrs:{"commit":_vm.commit,"collapsible":_vm.collapsible}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }